import Container from "../../../../components/container";
 
export default function ContactUsTableSkeleton() {
  return (
    <Container className="">
      {/* Mobile layout */}
      <div className="lg:hidden">
        {[...Array(3)].map((_, index) => (
          <div key={index} className="mb-2 w-full rounded-md bg-white p-4">
            <div className="h-4 bg-gray-300 rounded w-3/4 mb-2 animate-pulse"></div>
            <div className="flex items-center justify-between pb-4 mt-2">
              <div className="flex items-center gap-2">
                <div className="h-4 bg-gray-300 rounded w-16 animate-pulse"></div>
                <div className="h-4 bg-gray-300 rounded w-24 animate-pulse"></div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-4 bg-gray-300 rounded w-32 animate-pulse"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop table */}
      <table className="hidden min-w-full text-gray-900 text-left lg:table ">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th className="px-6 py-3">
              <div className="h-4 bg-gray-300 rounded w-20 animate-pulse"></div>
            </th>
            <th className="px-6 py-3">
              <div className="h-4 bg-gray-300 rounded w-20 animate-pulse"></div>
            </th>
            <th className="px-6 py-3">
              <div className="h-4 bg-gray-300 rounded w-20 animate-pulse"></div>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {[...Array(5)].map((_, index) => (
            <tr key={index} className="border-b">
              <td className="whitespace-nowrap px-6 py-3">
                <div className="h-4 bg-gray-300 rounded w-24 animate-pulse"></div>
              </td>
              <td className="px-6 py-4">
                <div className="h-4 bg-gray-300 rounded w-32 animate-pulse"></div>
              </td>
              <td className="px-6 py-4">
                <div className="h-4 bg-gray-300 rounded w-40 animate-pulse"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}